"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.402 18.961 2.566 5.248A.5.5 0 0 1 3 4.5h18.277a.5.5 0 0 1 .434.748l-7.836 13.713a2 2 0 0 1-3.473 0",
        clipRule: "evenodd"
      }
    )
  }
), m = e(t);
export {
  m as ArrowDownFilled,
  m as default
};
